var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconContactFacebook = function SvgIconContactFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 53,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 51,
    x: 1,
    y: 1.1,
    stroke: "#A36E21",
    rx: 3.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A36E21",
    d: "M28.5 28.1H31l1-4h-3.5v-2c0-1.03 0-2 2-2H32v-3.36c-.326-.043-1.557-.14-2.857-.14-2.715 0-4.643 1.657-4.643 4.7v2.8h-3v4h3v8.5h4z"
  })));
};
export default SvgIconContactFacebook;